/* eslint-disable */
import {
  Container,
  createStyles,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Theme,
  withStyles,
} from "@material-ui/core";
import { show } from "redux-modal";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { connectModal } from "redux-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import {
  getDirectoryDocuments,
  addDirectory,
  addDocumentFund,
  getFundEnvelopes,
  deleteDirectory,
  deleteDocument,
} from "../../utils/store/actions/document.actions";
import FolderIcon from "@material-ui/icons/Folder";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import ModalAddDocumentInDirectory from "./Modal.AddDocumentInDirectory";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import { TreeItem } from "@material-ui/lab";
import { baseUri } from "../../utils/uri";
import axios from "axios";
import { divide } from "lodash";

const styles = (theme: Theme) =>
  createStyles({
    dropzone: {
      minHeight: "150px",
      marginBottom: "20px",
    },
    previewChip: {
      width: "100px",
    },
  });

class ModalManageDocument extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      rootDirectories: [],
      rootDocuments: [],
      node: "root",
      parentDirectoryId: "",
      preview: false,
      BANK_TRANSFER: false,
      CHEQUE: false,
      DEBIT: false,
      fund: {
        countryOfIncorporation: "",
        fundAbaNumber: "",
        fundAccountName: "",
        fundAccountNumber: "",
        fundAgreementNumber: "",
        fundBankAddress: "",
        fundBankCity: "",
        fundBankCountry: "",
        fundBankName: "",
        fundBankPostalCode: "",
        fundCurrencyReference: "",
        fundDescription: "",
        fundIban: "",
        fundSrri: "",
        fundSwiftBicCode: "",
        fundWarning: "",
        isFundManagedByCompany: true,
        isMoralPersonFund: true,
        isOpened: true,
        displayColor: "#5e72e4",
        // maximumAcquiredEntranceFees: 0,
        // maximumEntranceFees: 0,
        // maximumNonAcquiredEntranceFees: 0,
        paymentTypes: [""],
        person: {
          fundType: "",
        },
        productFamily: "",
        regulationAuthority: "",
      },
      toast: false,
    };
  }
  componentDidMount() {
    this.props.getFundEnvelopes(this.props.Funds.fund.person.id);
  }
  async handleTreeItem(id: any, index: any) {
    if (index === "root") {
      this.setState({ node: index, parentDirectoryId: "" });
    } else {
      await this.props.getDirectoryDocuments(
        id,
        "fund",
        this.props.Funds.fund.person.id
      );
      this.setState({ node: index + 2, parentDirectoryId: id });
    }
  }
  handleDeleteDirectory(id: any) {
    this.props
      .deleteDirectory(id, "fund", this.props.Funds.fund.person.id)
      .then(() => {
        this.props.getFundEnvelopes(this.props.Funds.fund.person.id);
      });
  }
  handleDeleteDocument(id: any, directoryId: any) {
    this.props
      .deleteDocument(
        id,
        "fund",
        this.props.Funds.fund.person.id,
        this.state.open
      )
      .then(() => {
        if (this.state.open === "") {
          this.props.getFundEnvelopes(this.props.Funds.fund.person.id);
        } else {
          this.props.getDirectoryDocuments(
            directoryId,
            "fund",
            this.props.Funds.fund.person.id
          );
        }
      });
  }
  handlePreview(file: any) {
    axios({
      method: "get",
      url: `${baseUri}/service-document/v1/persons/${this.props.Funds.fund.person.id}/${this.state.open}/document/${file.id}`,
      responseType: "blob",
    }).then((res: any) => {
      this.setState({
        file: URL.createObjectURL(res.data),
        blob: res.data,
        fileName: file.name,
        open: true,
      });
      var element = document.createElement("a");
      element.href = this.state.file;
      element.setAttribute("download", `${file.name}`);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    });
  }
  TreeRender = (data: any, index: any) => {
    return (
      <TreeItem
        onClick={() => this.handleTreeItem(data.id, index)}
        key={data.id}
        icon={<FolderIcon style={{ color: "#7C88B1" }} />}
        nodeId={`${index + 2}`}
        label={data.name}
        style={{ padding: "12px" }}
      />
    );
  };
  render() {
    const { show, handleHide, t, classes } = this.props;
    const closeBtn = (
      <IconButton className="close" onClick={handleHide}>
        <CancelIcon />
      </IconButton>
    );
    return (
      <div>
        <ModalAddDocumentInDirectory />
        <Modal
          isOpen={show}
          toggle={handleHide}
          backdrop={true}
          style={{
            backgroundColor: "#f5f6ff",
            top: "20%",
            maxWidth: "fit-content",
          }}
        >
          <ModalHeader
            toggle={handleHide}
            close={closeBtn}
            style={{
              backgroundColor: "#f5f6ff",
              fontWeight: "bolder",
            }}
          >
            {t("ADD_DOCUMENT_OR_FOLDER")}
          </ModalHeader>
          <ModalBody
            style={{
              backgroundColor: "#f5f6ff",
            }}
          >
            <Container style={{ padding: 20 }}>
              <List
                style={{ maxHeight: 1000, overflow: "auto" }}
                className={classes.root}
              >
                {this.state.node === "root" ? (
                  <>
                    {this.props.Documents?.fundDocument?.length !== 0 ? (
                      this.props.Documents?.fundDocument?.map(
                        (directory: any, index: any) => {
                          return (
                            !directory.isDeleted && (
                              <>
                                <ListItem
                                  className={classes.listItem}
                                  key={directory.id}
                                  style={{
                                    borderBottom: "2px solid",
                                    borderColor: "#EAEDF7",
                                  }}
                                  onClick={() => {
                                    this.handleTreeItem(
                                      directory.id,
                                      index
                                    ).then(() =>
                                      this.setState({
                                        open:
                                          this.state.open === directory.id
                                            ? ""
                                            : directory.id,
                                      })
                                    );
                                  }}
                                >
                                  <ListItemAvatar>
                                    {this.state.open === directory.id ? (
                                      <FolderOpenIcon
                                        style={{
                                          height: "50px",
                                          width: "50px",
                                          color: "#AE0064",
                                        }}
                                      />
                                    ) : (
                                      <FolderIcon
                                        style={{
                                          height: "50px",
                                          width: "50px",
                                          color: "#AE0064",
                                        }}
                                      />
                                    )}
                                  </ListItemAvatar>

                                  <ListItemText
                                    id={directory.id}
                                    primary={this.props.t(directory.name)}
                                  />
                                  {directory.key !== "customDocumentDefault" ? (
                                    <ListItemSecondaryAction>
                                      <DeleteOutlinedIcon
                                        style={{ color: "#97A0C3" }}
                                        onClick={() => {
                                          this.handleDeleteDirectory(
                                            directory.id
                                          );
                                        }}
                                      />
                                    </ListItemSecondaryAction>
                                  ) : (
                                    <div></div>
                                  )}
                                </ListItem>
                              </>
                            )
                          );
                        }
                      )
                    ) : (
                      <div></div>
                    )}
                  </>
                ) : (
                  <>
                    {this.props.Documents.fundDocument &&
                    this.props.Documents.fundDocument.length !== 0 ? (
                      this.props.Documents.fundDocument.map(
                        (directory: any, index: any) => {
                          return (
                            !directory.isDeleted && (
                              <>
                                <ListItem
                                  className={classes.listItem}
                                  key={directory.id}
                                  style={{
                                    borderBottom: "2px solid",
                                    borderColor: "#EAEDF7",
                                  }}
                                  onClick={() => {
                                    this.handleTreeItem(
                                      directory.id,
                                      index
                                    ).then(() =>
                                      this.setState({
                                        open:
                                          this.state.open === directory.id
                                            ? ""
                                            : directory.id,
                                      })
                                    );
                                  }}
                                >
                                  <ListItemAvatar>
                                    {this.state.open === directory.id ? (
                                      <FolderOpenIcon
                                        style={{
                                          height: "50px",
                                          width: "50px",
                                          color: "#AE0064",
                                        }}
                                      />
                                    ) : (
                                      <FolderIcon
                                        style={{
                                          height: "50px",
                                          width: "50px",
                                          color: "#AE0064",
                                        }}
                                      />
                                    )}
                                  </ListItemAvatar>

                                  <ListItemText
                                    id={directory.id}
                                    primary={this.props.t(directory.name)}
                                  />
                                  {directory.key !== "customDocumentDefault" ? (
                                    <ListItemSecondaryAction>
                                      <DeleteOutlinedIcon
                                        style={{ color: "#97A0C3" }}
                                        onClick={() => {
                                          this.handleDeleteDirectory(
                                            directory.id
                                          );
                                        }}
                                      />
                                    </ListItemSecondaryAction>
                                  ) : (
                                    <div></div>
                                  )}
                                </ListItem>
                                {this.props.Documents.directory_documents &&
                                  this.props.Documents.directory_documents
                                    .documents &&
                                  this.state.open === directory.id &&
                                  this.props.Documents.directory_documents.documents.map(
                                    (doc: any) => (
                                      <>
                                        <ListItem
                                          className={classes.listItem}
                                          key={doc.id}
                                          style={{
                                            marginLeft: "3vh",
                                            borderBottom: "2px solid",
                                            borderColor: "#EAEDF7",
                                          }}
                                          onClick={() => {
                                            this.handlePreview(doc);
                                          }}
                                        >
                                          <ListItemAvatar>
                                            <InsertDriveFileIcon
                                              style={{
                                                height: "50px",
                                                width: "50px",
                                                color: "#7C88B1",
                                              }}
                                            />
                                          </ListItemAvatar>

                                          <ListItemText
                                            id={doc.id}
                                            primary={doc.name}
                                          />

                                          <ListItemSecondaryAction>
                                            <DeleteOutlinedIcon
                                              style={{
                                                color: "#97A0C3",
                                              }}
                                              onClick={() => {
                                                this.handleDeleteDocument(
                                                  doc.id,
                                                  directory.id
                                                );
                                              }}
                                            />
                                          </ListItemSecondaryAction>
                                        </ListItem>
                                      </>
                                    )
                                  )}
                              </>
                            )
                          );
                        }
                      )
                    ) : (
                      <div></div>
                    )}
                  </>
                )}
              </List>
              <Container style={{ padding: "20px", display: "flex" }}>
                {this.state.open ? (
                  <Button
                    style={{ textTransform: "none", width: "100%" }}
                    onClick={(e: any) =>
                      this.props.showModal("add_doc_directory", {
                        name: "add_doc_directory",
                        history,
                        actionDone: "DOCUMENT_FUND",
                        parentDirectoryId: this.state.open,
                      })
                    }
                  >
                    <AddCircleOutlineIcon
                      style={{
                        color: "#ae0064",
                        marginRight: "20px",
                      }}
                    />
                    {t("ADD_DOCUMENT")}
                  </Button>
                ) : (
                  <Button
                    style={{ textTransform: "none", width: "100%" }}
                    onClick={(e: any) =>
                      this.props.showModal("add_doc_directory", {
                        name: "add_doc_directory",
                        history,
                        actionDone: "DIRECTORY_FUND",
                        parentDirectoryId: this.props.Funds.fund.person.id,
                      })
                    }
                  >
                    <AddCircleOutlineIcon
                      style={{
                        color: "#ae0064",
                        marginRight: "20px",
                      }}
                    />
                    {t("ADD_DIRECTORY")}
                  </Button>
                )}
              </Container>
            </Container>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});
const mapDispatchToProps = {
  showModal: show,
  getDirectoryDocuments,
  addDirectory,
  addDocumentFund,
  getFundEnvelopes,
  deleteDirectory,
  deleteDocument,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslation()(
    withStyles(styles)(
      connectModal({ name: "manage_document" })(ModalManageDocument)
    )
  )
);
